import React from 'react';
import { Card, Button, Row, Col, Container, Accordion, Carousel } from 'react-bootstrap';
import ContainerSideBarComponent from '../component/container/ContainerSidebarComponent';
import AlertComponent from '../component/alert/AlertComponent';

interface CarouselItem {
  image: string;
  title: string;
  content: string;
}

const HomePage: React.FC = () => {
  /** CAROUSEL */
  const TIME_INTERVAL_CAROUSEL = 5000;
  const carouselItems: CarouselItem[] = [
    {
      image: require('../images/Carrousel1.jpg'),
      title: 'Ambiente Moderno',
      content: 'Sua clínica com uma estrutura acolhedora e moderna.',
    },
    {
      image: require('../images/Carrousel2.jpg'),
      title: 'Tecnologia de Ponta',
      content: 'Equipamentos modernos para garantir o melhor atendimento.',
    },
    {
      image: require('../images/Carrousel3.jpg'),
      title: 'LUME',
      content:
        'O INTELIDENTE fornece informações essenciais para auxiliar sua empresa nas tomadas de decisões estratégicas, visando o aumento da lucratividade, redução de custos e otimização de recursos.',
    },
    {
      image: require('../images/Carrousel4.jpg'),
      title: 'Equipe Especializada',
      content: 'Contamos com os melhores profissionais do mercado.',
    },
  ];

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <div>
        <h1>
          Bem Vindo ao Intelidente <i>Lite</i>.
        </h1>
        <p>Gerenciamento completo para sua clínica odontológica.</p>
      </div>

      <Container className="mt-5">
        <Carousel variant="dark">
          {carouselItems.map((item, index) => {
            return (
              <Carousel.Item interval={TIME_INTERVAL_CAROUSEL} key={index}>
                <img
                  className="d-block w-100"
                  src={item.image}
                  alt={item.title}
                  style={{ height: '400px', objectFit: 'cover' }} // Dimensão uniforme para as imagens
                />
                <Carousel.Caption>
                  <h3>{item.title}</h3> {/* Texto com cor personalizada */}
                  <p>{item.content}</p> {/* Texto com cor personalizada */}
                </Carousel.Caption>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </Container>
    </ContainerSideBarComponent>
  );
};

export default HomePage;
